import React from 'react';
import styled from 'styled-components';

const Bar = styled.div`display: flex; gap: 2px; height: 10px;`;
const Segment = styled.div`flex-basis: 0; min-width: 4px; border-radius: 3px;`;

// Parts of a whole on one line. A segment with an href-less title still explains itself on hover.
const SegmentBar = ({ segments, width = '100%' }) => (
    <Bar style={{ width }}>
        {segments.filter((segment) => segment.value > 0).map((segment) => (
            <Segment
                key={segment.key}
                title={segment.title}
                style={{ flexGrow: segment.value, background: segment.color }}
            />
        ))}
    </Bar>
);

export default SegmentBar;
